/**
 * Actions feature auto-registration and exports
 *
 * This module automatically registers the actions feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';
import { actionsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(actionsFeature);

// Export store (all store-related exports)
export * from './store';

// Export components
export { Actions } from './components';

// Export types
export * from './types';

// Export constants
export * from './constants';
